<template>
  <div class="relative w-$portalContainerWidth mx-auto mt-20px">
    <NavigationBarProps></NavigationBarProps>
    <div class="flex mt-20px">
      <div class="w-1/3 mr-10px">
        <column-header class="mb-10px" title="行政办公" :showMore="false" @loadMore="loadMore(1)" />
        <div class="w-full flex">
          <div
            class="
              w-full
              h-50px
              bg-hex-F0F9FF
              rounded-6px
              flex
              items-center
              justify-center
              cursor-pointer
            "
            @click="toHandle(1)"
          >
            <div class="w-20px h-20px ml-10px clock"></div>
            <div class="flex-1 flex justify-between px-10px justify-center items-center">
              <span class="text-14px text-hex-3B9BF0">我的待办</span>
              <span class="text-24px text-hex-3B9BF0 font-bold flex items-center"
                >{{ page.total }}<i class="el-icon-arrow-right text-20px font-bold"></i
              ></span>
            </div>
          </div>
        </div>
        <div class="w-full flex mt-10px">
          <!-- <div
            class="w-1/2 h-50px mr-5px bg-hex-F0F9FF rounded-6px flex items-center justify-center cursor-pointer"
            @click="toHandle(2)"
          >
            <div class="w-20px h-20px ml-10px initiate"></div>
            <div class="flex-1 flex justify-between px-10px justify-center items-center">
              <span class="text-14px text-hex-3B9BF0">我发起的</span>
            </div>
          </div> -->
          <div
            class="
              w-full
              h-50px
              bg-hex-EAFFEF
              rounded-6px
              flex
              items-center
              justify-center
              cursor-pointer
            "
            @click="toHandle(3)"
          >
            <div class="w-20px h-20px ml-10px complete"></div>
            <div class="flex-1 flex justify-between px-10px justify-center items-center">
              <span class="text-14px text-hex-25E154">我的已办</span>
              <span class="text-24px text-hex-25E154 font-bold flex items-center"
                >{{ doneListNum }}<i class="el-icon-arrow-right text-20px font-bold"></i
              ></span>
            </div>
          </div>
          <!-- <div
            class="w-1/3 h-50px ml-5px bg-hex-FFF8F0 rounded-6px flex items-center justify-center cursor-pointer"
          >
            <div class="w-20px h-20px ml-10px draft"></div>
            <div class="flex-1 flex justify-between px-10px justify-center items-center">
              <span class="text-14px text-hex-FFC01D">草稿箱</span>
            </div>
          </div> -->
        </div>
        <div class="w-full mt-20px mb-20px border-t-1 border-dashed border-hex-E2E2E2"></div>
        <div
          class="
            w-full
            h-[calc(100%-240px)]
            min-h-150px
            overflow-x-hidden overflow-y-scroll
            showTable
          "
        >
          <div class="h-full w-full">
            <div
              v-for="(it, index) in list"
              :key="index"
              class="
                mb-15px
                cursor-pointer
                flex
                items-center
                justify-between
                hover:text-hex-$portalPrimaryColor
              "
              @click="liClick(it)"
            >
              <div class="flex items-center w-[calc(100%-50px)]">
                <div class="bg-$portalPrimaryColor w-6px h-6px rounded-1/2"></div>
                <p
                  class="text-14px truncate pl-10px w-[calc(100%-6px)]"
                  :title="`门户稿件发布申请-${it.creatorName}-${it.title}`"
                >
                  门户稿件发布申请-{{ it.creatorName }}-{{ it.title }}
                </p>
              </div>
              <div class="w-50px text-14px text-right text-hex-999">
                {{ dayjs(it.receiveTime).format('MM/DD') }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-10px" v-if="list.length">
          <el-pagination
            small
            background
            @current-change="handleCurrentChange"
            :pager-count="5"
            :current-page.sync="page.pageNum"
            :page-size.sync="page.pageSize"
            layout="total, prev, pager, next"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="w-1/3 mr-10px">
        <component :is="announcement.listStyle" :data="announcement" mode="view"></component>
      </div>
      <div class="w-1/3">
        <component :is="news.listStyle" :data="news" mode="view"></component>
      </div>
    </div>
    <div class="w-full mt-20px">
      <column-header class="mb-10px" title="智慧应用" @loadMore="loadMore(2)" />
      <div class="flex relative">
        <div class="flex-1">
          <el-carousel
            ref="nop"
            :interval="5000"
            trigger="click"
            indicator-position="none"
            :arrow="appList.length <= 6 ? 'never' : ''"
            height="100px"
            :autoplay="false"
          >
            <el-carousel-item v-for="(items, i) in carouselList" :key="i">
              <div class="w-full" :class="items.length === 6 ? 'flex justify-between' : ''">
                <div
                  class="
                    w-180px
                    h-100px
                    app-item
                    inline-flex
                    justify-center
                    relative
                    cursor-pointer
                    items-center
                    flex-col
                    bg-hex-FFF8F8
                  "
                  :class="items.length === 6 ? 'mr-0' : 'mr-20px'"
                  v-for="(item, index) in items"
                  :key="index"
                  @click="toApp(item)"
                >
                  <div class="w-40px h-40px image">
                    <img :src="`${fileUrl}${item.normalIcon}`" alt="" />
                    <img :src="`${fileUrl}${item.hoverIcon}`" alt="" />
                  </div>
                  <div class="text-14px font-normal mt-4px text-hex-000000">{{ item.name }}</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <AddSSOConfig @save="ssoSave" :appConfig="appConfig" ref="addSSOConfig" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { SingleSignOnApi, WorkbenchSettingApi, ColumnTableSearchApi } from '@wiz-api/workbench'
import { FlowTaskApi } from '@wiz-api/road-flow-ele'
import { EafLoginApi } from '@wiz-api/auth-server'
import NavigationBarProps from '../components/NavigationBarProps'
import AddSSOConfig from '../components/AddSSOConfig'
import { getFieldValue, ssoLogin } from '../js/sso'

const columnHeader = () => {
  return import('../../../components/portal/ColumnHeader')
}
const NewsTwo = () => {
  return import('../../../components/portal/NewsTwo')
}
const NewsOne = () => {
  return import('../../../components/portal/NewsOne')
}
const NewsThree = () => {
  return import('../../../components/portal/NewsThree')
}
const NewsFour = () => {
  return import('../../../components/portal/NewsFour')
}
const columnTableSearchApi = new ColumnTableSearchApi()
const workbenchSettingApi = new WorkbenchSettingApi()
const singleSignOnApi = new SingleSignOnApi()
const flowTaskApi = new FlowTaskApi()
const eafLoginAPi = new EafLoginApi()
const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
export default {
  components: {
    columnHeader,
    NewsTwo,
    NewsOne,
    NewsThree,
    NewsFour,
    NavigationBarProps,
    AddSSOConfig,
  },
  data() {
    return {
      newsList: [],
      list: [],
      page: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      appList: [],
      appConfig: {},
      carouselList: [],
      announcement: {
        dataSource: '', // 数据来源
        listStyle: 'NewsTwo', // 显示样式
        showContent: false, // 显示摘要
        showDate: false, // 显示时间
        showPagination: false, // 显示分页
        showTitle: false, // 显示栏目名称
        pageSize: 1, // 展示条数
      },
      news: {
        dataSource: '', // 数据来源
        listStyle: 'NewsTwo', // 显示样式
        showContent: false, // 显示摘要
        showDate: false, // 显示时间
        showPagination: false, // 显示分页
        showTitle: false, // 显示栏目名称
        pageSize: 1, // 展示条数
      },
      doneList: [],
      doneListNum: 0,
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  mounted() {
    document.title = `工作台 - ${config.title}`
    this.getTodoList()
    this.getDoneList()
    this.getWitApp()
    this.getWorkbenchSetting()
  },
  methods: {
    toHandle(type) {
      const path = '/portal-management/person-agency'
      // switch (type) {
      //   case 1:
      //     path = '/flow-management/todo'
      //     break
      //   case 2:
      //     path = '/flow-management/mystart'
      //     break
      //   case 3:
      //     path = '/flow-management/completed'
      //     break
      //   default:
      //     break
      // }
      this.$router.push({
        path: `${this.routerBase}${path}`,
        query: {
          activeTab: type === 1 ? 'todo' : 'done',
        },
      })
    },
    async getTodoList() {
      // const params = {
      //   pageSize: this.page.pageSize,
      //   pageNumber: this.page.pageNum,
      //   order: 'receivetime des',
      //   title: '',
      //   startDateTime: '',
      //   endDateTime: '',
      //   flowId: 0,
      // }
      // const [err, res] = await flowTaskApi.roadFlowOpenApiFlowTaskV11GetTodoListPost({
      //   body: {
      //     raw: JSON.stringify(params),
      //   },
      // })
      const [err, res] = await columnTableSearchApi.getTodoColumnTableV(
        this.page.pageNum,
        this.page.pageSize,
        {
          isCompeleted: false,
        }
      )
      if (!err && res) {
        this.list = _.map(res.items, (item) => {
          item.creationTime = item.creationTime
            ? dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          item.flowInfo.receiveTime = dayjs(item.flowInfo.receiveTime).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.page.total = res.totalCount
      }
    },
    async getDoneList() {
      // const params = {
      //   pageSize: this.page.pageSize,
      //   pageNumber: this.page.pageNum,
      //   order: 'receivetime des',
      //   title: '',
      //   startDateTime: '',
      //   endDateTime: '',
      //   flowId: 0,
      // }
      // const [err, res] = await flowTaskApi.roadFlowOpenApiFlowTaskV11GetTodoListPost({
      //   body: {
      //     raw: JSON.stringify(params),
      //   },
      // })
      const [err, res] = await columnTableSearchApi.getTodoColumnTableV(
        this.page.pageNum,
        this.page.pageSize,
        {
          isCompeleted: true,
        }
      )
      if (!err && res) {
        this.doneList = _.map(res.items, (item) => {
          item.creationTime = item.creationTime
            ? dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          item.flowInfo.receiveTime = dayjs(item.flowInfo.receiveTime).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.doneListNum = res.totalCount
      }
    },
    async getWitApp() {
      const params = {
        name: '',
        isThirdParty: '',
        type: '',
      }
      const [err, res] = await singleSignOnApi.getAppssoSettingPage(1, 999, params)
      if (!err && res) {
        this.appList = res?.items
        this.filter(res.items)
      }
    },
    liClick(row) {
      // this.$router.push({
      //   path: '/portal/workflows',
      //   query: {
      //     flowid: row.flowId,
      //     stepid: row.stepId,
      //     taskid: row.id,
      //     groupid: row.groupId,
      //     instanceid: row.instanceId,
      //   },
      // })

      this.$router.push({
        path: `${this.routerBase}/portal-management/information-publish/column-publish-detail`,
        query: {
          columnId: row.columnId,
          id: row.columnTableId,
          mode: row.workflowStatus === 1 ? 'approve' : 'submit',
        },
      })
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getTodoList()
    },
    filter(val) {
      if (val && val.length > 6) {
        const row = Math.ceil(val.length / 6)
        this.carouselList = []
        for (let i = 0; i < row; i += 1) {
          this.carouselList[i] = []
          for (let j = 0; j < 6; j += 1) {
            const index = i * 6 + j
            if (index < val.length) {
              this.carouselList[i][j] = val[index]
            }
          }
        }
      } else {
        this.carouselList = []
        this.carouselList.push(val)
      }
    },
    async getWorkbenchSetting() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'leftWorkbench' })
      const [errRight, resRight] = await workbenchSettingApi.getWorkbenchSetting({
        code: 'rightWorkbench',
      })
      if (!err && res) {
        const filterData = JSON.parse(res.config)
        this.announcement.dataSource = filterData.source
        this.announcement.row = filterData.row
        this.announcement.col = filterData.col
        this.announcement.listStyle = filterData.listStyle
        filterData.displayContent.indexOf('显示摘要') !== -1
          ? (this.announcement.showContent = true)
          : (this.announcement.showContent = false)
        filterData.displayContent.indexOf('显示时间') !== -1
          ? (this.announcement.showDate = true)
          : (this.announcement.showDate = false)
        filterData.displayContent.indexOf('显示分页') !== -1
          ? (this.announcement.showPagination = true)
          : (this.announcement.showPagination = false)
        filterData.displayContent.indexOf('显示栏目名称') !== -1
          ? (this.announcement.showTitle = true)
          : (this.announcement.showTitle = false)
      }
      if (!errRight && resRight) {
        const filterData = JSON.parse(resRight.config)
        this.news.dataSource = filterData.source
        this.news.row = filterData.row
        this.news.col = filterData.col
        this.news.listStyle = filterData.listStyle
        filterData.displayContent.indexOf('显示摘要') !== -1
          ? (this.news.showContent = true)
          : (this.news.showContent = false)
        filterData.displayContent.indexOf('显示时间') !== -1
          ? (this.news.showDate = true)
          : (this.news.showDate = false)
        filterData.displayContent.indexOf('显示分页') !== -1
          ? (this.news.showPagination = true)
          : (this.news.showPagination = false)
        filterData.displayContent.indexOf('显示栏目名称') !== -1
          ? (this.news.showTitle = true)
          : (this.news.showTitle = false)
      }
    },
    loadMore(type) {
      let path = ''
      switch (type) {
        case 1:
          path = '/portal-management/person-agency'
          break
        case 2:
          path = '/portal/appCenter'
          break
        default:
          break
      }
      this.$router.push({
        path: `${this.routerBase}${path}`,
      })
    },
    async toApp(app) {
      const loginParams = app.moreParamSetting ? JSON.parse(app.moreParamSetting) : []
      let url = ''
      _.forEach(loginParams, (item) => {
        if (item.postType === 'url') {
          url += `&${item.fieldsName}=${getFieldValue(item)}`
        }
      })
      // 0:直接跳转 3：auth2.0
      if (app.loginType === 0) {
        window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
      } else if (app.loginType === 3) {
        const [err, res] = await eafLoginAPi.takeOidcCode(
          'SSO_APP',
          app.loginUrl,
          'code',
          'openid profile'
        )
        if (!err) {
          if (res.isSuccess) {
            url += `&code=${res.code}`
            window.open(`${app.loginUrl}${url ? url.replace('&', '?') : ''}`)
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      } else {
        const [err, res] = await singleSignOnApi.getAppssoParamsDetail({
          userId: this.userInfo?.profile?.sub,
          appId: app.id,
        })
        if (!err) {
          if (res.id !== '00000000-0000-0000-0000-000000000000') {
            ssoLogin(app, res)
          } else {
            this.appConfig = app
            this.$refs.addSSOConfig.dialogVisible = true
          }
        }
      }
    },
    ssoSave(data) {
      ssoLogin(this.appConfig, data)
      this.getWitApp()
    },
  },
}
</script>

<style lang="scss" scoped>
.clock {
  background: url('../image/clock.png') 0 0 no-repeat;
  background-size: 100%;
}
.aeroplane {
  background: url('../image/aeroplane.png') 0 0 no-repeat;
  background-size: 100%;
}
.initiate {
  background: url('../image/initiate.png') 0 0 no-repeat;
  background-size: 100%;
}
.complete {
  background: url('../image/done.png') 0 0 no-repeat;
  background-size: 100%;
}
.draft {
  background: url('../image/draft.png') 0 0 no-repeat;
  background-size: 100%;
}
.showTable {
  &::-webkit-scrollbar {
    width: 0px !important;
    display: none !important;
  }
}
.app-item {
  &:hover {
    background-color: var(--portalPrimaryColor);
    color: #fff;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 30px;
      height: 30px;
      background: url('../image/active.png') 0 0 no-repeat;
      background-size: 100%;
    }
    .image img:last-child {
      display: block;
    }
    .image img:first-child {
      display: none;
    }
  }
  .image img:first-child {
    display: block;
  }
  .image img:last-child {
    display: none;
  }
}
</style>
